import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { LogGroup, Scale, CreateElement, Size, Log } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";
import { CommonTranslatedSprite } from "../../../CommonTranslatedSprite";
import { Settings } from "../../../../Settings";
import { ITranslatedCanvasParams } from "../../../TranslatedCanvasSprite";

export class BigFreeGamePlusOneSlideDoubleSlide extends Slide {
    protected logGroup: LogGroup;
    protected resid: ResourceIdentifier;
    protected systemContext: ISystemContext;
    //protected maxFreeGames: number = 0;
    protected SpriteFreegame: CanvasSprite = null;    
    protected SripiteTimer: IInterval;
    protected TitleSripiteTimer: IInterval;
    protected bigFreeGamePlusOneSpriteTranslator: CommonTranslatedSprite  = null;
    constructor(initData: SlotGameInitData, p: SlideFactory2Params, viewSize: Size) {
        super(initData, p, viewSize);
        this.viewSize = viewSize;
        this.logGroup = new LogGroup("BigFreeGamePlusOneSlideDoubleSlide");
        this.resid = p.resid.Add("BigFreeGamePlusOneSlideDoubleSlide");
        this.systemContext = p.systemContext.CreateSubContext("BigFreeGamePlusOneSlideDoubleSlide");
        //slide
        this.view = CreateElement("div", {
            classes: ["BigFreeGameBonusPlusOne", this.resid.Scope()],
            style: {
                position: "absolute",
                height: this.viewSize.Height + "px",
                width: this.viewSize.Height + "px",
            }
        });

        let path = Settings.ResourcesFolder + "multigame/slot/common/resources/BigSymbolFreegames/resources/Sliders2/FGRight"; 
        let params: ITranslatedCanvasParams = {
            resid: this.resid,
            path: path,
            logGroup: this.logGroup,
            viewSize: this.viewSize,
            nameSpriteSlide: "FGRight",
            translator: this.translator,
        }
        this.bigFreeGamePlusOneSpriteTranslator = new CommonTranslatedSprite(params);
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //resourceManager.AddGlobal(new PixiSpriteResource(this.commonPath2 + "Slider2/FGRight", ResourceIdentifier.Global.Add(this.initData.Name + "FGRight").Add("BigFreeGameBonusPlusOne"), true, this.logGroup.Add("BigFreeGameBonusPlusOne"), true));
        this.bigFreeGamePlusOneSpriteTranslator.PrepareResources(resourceManager);
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        this.bigFreeGamePlusOneSpriteTranslator.ResourcesLoaded(resourceManager);
        this.view.appendChild(this.bigFreeGamePlusOneSpriteTranslator.View());
        this.TitleSripiteTimer = this.systemContext.TimingContext().CreateInterval("BigFreeGameBonusPlusOne", this.nextAnimInterval, () => this.bigFreeGamePlusOneSpriteTranslator.Start());
    }


    public override View(): HTMLElement {
        return this.view;
    }
    public override Update() {

        this.bigFreeGamePlusOneSpriteTranslator.Update();
    }
    public override Start() {
        this.TitleSripiteTimer.Start();
    }

    public override Stop() {
        this.TitleSripiteTimer.Stop();
        //this.SpriteFreegame.StopAndReset()
    }
}
